import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Moment } from "moment-jalaali";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import DayTotalUsageApi from "../api/day-total-usage";
import AuthContext from "../components/auth-context";
import DatePicker from "../components/inputs/date-picker";
import SGrid from "../components/sgrid";
import { IGridFilterRule } from "../types/grid-filters";
import Row from "../components/tailwind/row";
import Col from "../components/tailwind/col";

export interface IUsages {
  isNgnService?: boolean;
  ngnTellNumber?: string;
}

export default function Usages() {
  const context = useContext(AuthContext);
  const { activeFileId } = context;

  const [fromDate, setFromDate] = useState<Moment | undefined>();
  const [toDate, setToDate] = useState<Moment | undefined>();

  const { t } = useTranslation();

  const rules: IGridFilterRule[] = [];

  if (fromDate) {
    rules.push({
      field: "DayDate",
      op: "ge",
      data: fromDate.format("jYYYY/jMM/jDD"),
    });
  }

  if (toDate) {
    rules.push({
      field: "DayDate",
      op: "le",
      data: toDate.format("jYYYY/jMM/jDD"),
    });
  }

  const toNumber = (value: unknown): number => {
    const normalizedValue = String(value ?? "")
      .replace(/,/g, "")
      .trim();
    const numberValue = Number(normalizedValue);
    return Number.isFinite(numberValue) ? numberValue : 0;
  };

  const transformPayload = (target: any) => {
    if (!target) return target;

    if (Array.isArray(target.rows)) {
      target.rows = target.rows.map((row: any) => {
        if (Array.isArray(row?.cell) && row.cell.length >= 7) {
          const newCell = [...row.cell];
          const v5 = toNumber(newCell[5]);
          const v6 = toNumber(newCell[6]);
          newCell[5] = v5 - v6;
          return {
            ...row,
            cell: newCell,
          };
        }
        return row;
      });
    }

    if (Array.isArray(target.userdata) && target.userdata.length >= 7) {
      const newUdata = [...target.userdata];
      const u5 = toNumber(newUdata[5]);
      const u6 = toNumber(newUdata[6]);
      newUdata[5] = u5 - u6;
      target.userdata = newUdata;
    } else if (
      Array.isArray(target.userdata?.cell) &&
      target.userdata.cell.length >= 7
    ) {
      const newUcell = [...target.userdata.cell];
      const u5 = toNumber(newUcell[5]);
      const u6 = toNumber(newUcell[6]);
      newUcell[5] = u5 - u6;
      target.userdata = {
        ...target.userdata,
        cell: newUcell,
      };
    }

    return target;
  };

  const dataProvider = async (page: number, pageSize: number) => {
    const response = await new DayTotalUsageApi(context).getAll(activeFileId!, {
      page,
      rows: pageSize,
      filters: {
        groupOp: "AND",
        rules,
      },
    });

    if (response?.data?.rows) {
      transformPayload(response.data);
    }
    if (response?.rows) {
      transformPayload(response);
    }

    return response;
  };

  return (
    <>
      <Row className="my-3">
        <Col>
          <ul className="list-unstyled">
            <li>
              <FontAwesomeIcon
                icon="exclamation-triangle"
                className="w-3 text-orange mr-2"
              />
              {t("Usages.WarningText")}
            </li>
          </ul>
        </Col>
      </Row>

      <div className="card">
        <div className="card-header">
          <h6 className="card-title">فیلتر تاریخ</h6>
        </div>

        <div className="card-body">
          <DatePicker label="از" value={fromDate} onChange={setFromDate} />

          <DatePicker label="تا" value={toDate} onChange={setToDate} />
        </div>
      </div>

      <div className="dcard mt-3 overflow-x-scroll" style={{ padding: "5px" }}>
        <SGrid
          key={`${fromDate?.valueOf() ?? ""}-${toDate?.valueOf() ?? ""}`}
          dataProvider={dataProvider}
          columns={[
            ["تاریخ", "date", 0],
            ["بین‌الملل (مگا بایت)", "farsi", 1],
            "",
            ["داخلی (مگا بایت)", "farsi", 5],
            ["پیام‌رسان (مگا بایت)", "farsi", 6],
          ]}
        />
      </div>
    </>
  );
}
